/**
 * CMS content type identifiers used in preview system.
 * These should match the 'type' parameter sent to /api/preview from Strapi plugin config.
 */
export enum CmsContentTypeEnum {
    HERO = 'hero',
    MARKETING_BANNER = 'marketing-banner',
    PROMOTED_DESTINATIONS = 'promoted-dest',
    HORIZONTAL_BANNER = 'horizontal-banner',
    // FEATURED_ACCOMMODATION = 'featured-accommodation',
    // etc.
}
